export const fractionToPercent = (fraction: number) => Number((fraction * 100).toFixed(2))
